import * as React from 'react';

import ProjectInstructionsModule from 'bundles/unified-description-page-common/components/modules/project-instructions/ProjectInstructions';
import { PROJECTS_LEARN_ANCHOR_ID } from 'bundles/unified-description-page-common/constants';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import getProjectInstructions from 'bundles/unified-description-page-common/data/project-instructions';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import getProjectInstructionsBackgroundImage from 'bundles/unified-description-page-common/utils/getProjectInstructionsBackgroundImage';

import _t from 'i18n!nls/xdp';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
};

const ProjectInstructionsModuleRenderer = ({ pageData }: Props) => {
  const { pageType } = usePageInfo();
  if (!pageData.courseType) {
    return null;
  }

  const instructions = getProjectInstructions(pageData.courseType);

  return (
    <ProjectInstructionsModule
      instructions={instructions}
      backgroundImage={getProjectInstructionsBackgroundImage(pageType)}
      title={_t("How you'll learn")}
      anchorId={PROJECTS_LEARN_ANCHOR_ID}
    />
  );
};

export default ProjectInstructionsModuleRenderer;
